/**
 * @file
 * Product page scripts.
 */

// Set images width on product slideshow.
const $productGallery = $('.product-image .product-gallery', context);

$productGallery.once('product-page-gallery').each((index, el) => {
  const $this = $(el);
  const galleryLength = $this.find('.product-gallery-image').length;

  const setGalleryWidth = () => {
    if (galleryLength < 4 || $(window).width() < 1024) {
      $this.removeAttr('style');
      return;
    }
    const imageHeight = $this
      .find('.product-gallery-image')
      .eq(0)
      .height();

    $this.css('width', imageHeight);
  };

  setGalleryWidth();
  $(window).resize(setGalleryWidth);
});
